import Vue from 'vue'

export default Vue.extend({
  template: `
    <div class="admin-actions-renderer">
      <span
        v-if="params.onInfo"
        v-b-tooltip :title="params.infoTitle || 'Информация'"
        class="mr-2 fas fa-info-circle text-primary text-center"
        @click="onInfoClicked"
      ></span>
      <span
        v-if="params.onEdit"
          v-b-tooltip title="Редактировать"
          class="mr-2 fas fa-edit text-primary text-center"
          @click="onEditClicked"
      ></span>
      <span
        v-if="params.onCopy"
        v-b-tooltip :title="params.copyTitle || 'Копировать'"
        class="adminAction fas fa-clone text-primary text-center mr-2"
        @click="onCopyClicked"
      ></span>
      <span
          v-if="params.onDelete"
          v-b-tooltip.left title="Удалить"
          class="adminAction fas fa-times text-danger text-center"
          @click="onDeleteClicked"
      ></span>
    </div>
  `,
  methods: {
    onInfoClicked() {
      this.params.onInfo(this.params.node.data)
    },
    onEditClicked() {
      this.params.onEdit(this.params.node.data)
    },
    onDeleteClicked() {
      this.params.onDelete(this.params.node.data)
    },
    onCopyClicked() {
      this.params.onCopy(this.params.node.data)
    }
  }
})
